






































































import VideoUrlDecoderMixin from './../mixins/videoUrlDecoder';

export default {
  name: 'SilentboxOverlay',
  mixins: [VideoUrlDecoderMixin],
  data() {
    return {
      video: false,
    };
  },
  computed: {
    /**
     * Get the right embed URL.
     */
    getEmbedUrl() {
      return this.handleUrl(this.$parent.embedUrl);
    },
    /**
     * Get autoplay state.
     */
    getAutoplayState() {
      if (
        this.$parent.autoplay !== undefined &&
        this.$parent.autoplay !== false
      ) {
        return 'autoplay';
      }
      return '';
    },
    /**
     * Check whether overlay is visible or not.
     */
    isVisible() {
      if (
        this.$parent.overlayVisibility !== undefined &&
        this.$parent.overlayVisibility !== false
      ) {
        return true;
      }

      return false;
    },
  },
  watch: {
    isVisible: function (value) {
      if (document !== undefined) {
        this.bodyScrolling();
      }
    },
  },
  methods: {
    bodyScrolling() {
      const body = document.body;

      // add class only if overlay should be visible
      if (this.isVisible && !body.classList.contains('silentbox-is-opened')) {
        return body.classList.add('silentbox-is-opened');
      }

      // remove class only if overlay should be hidden
      if (!this.isVisible && body.classList.contains('silentbox-is-opened')) {
        return body.classList.remove('silentbox-is-opened');
      }
    },
    /**
     * Move to next item.
     */
    moveToNextItem() {
      this.$parent.nextItem();
    },
    /**
     * Move to previous item.
     */
    moveToPreviousItem() {
      this.$parent.prevItem();
    },
    /**
     * Hide silentbox overlay.
     */
    closeSilentboxOverlay() {
      this.$parent.$emit('closeSilentboxOverlay');
    },
    /**
     * Search for known video services URLs and return their players if recognized.
     * Unrecognized URLs are handled as images.
     *
     * @param  {string} url
     * @return {string}
     */
    handleUrl(url) {
      if (url.includes('youtube.com') || url.includes('youtu.be')) {
        this.video = true;
        return this.getYoutubeEmbedUrl(url, {
          autoplay: this.$parent.autoplay,
          controls: this.$parent.showControls,
        });
      } else if (url.includes('vimeo')) {
        this.video = true;
        return this.getVimeoEmbedUrl(url, { autoplay: this.$parent.autoplay });
      } else if (url.includes('spark.adobe.com') || url.includes('express.adobe.com')) {
        this.video = true;
        return url;
      } else {
        // Given url is not a video URL thus return it as it is.
        this.video = false;
        return url;
      }
    },
  },
};
